import { intersect, unique } from '../../utils/array';

const filterProducts = ({ baseProducts = [], filterArrays, filter, products, categories }) => {
	/*
		Filter

		This could benefit from memoization - reselect

		Filters which don't match the base list of products are removed i.e. women men etc.
		Filters which don't match the current categories' list of products are disabled. Except categories.
	*/

	baseProducts = baseProducts.filter((rbp) => products[rbp] !== undefined);
	let relevantProducts = [...baseProducts];

	const filteredProducts = {};

	// Filter only relevant products
	filter.filteredBy.forEach((filterObj) => {
		const filterType = Object.keys(filterObj)[0];
		const filterItem = filterObj[filterType];
		if (filterItem === true || (Array.isArray(filterItem) && filterItem.length > 0)) {
			// Products are filtered
			// Need to update relevantProducts on every pass.
			switch (filterType) {
				case 'categories': {
					const filterCategoriesItem = filterItem.length > 1 ? filterItem.slice(1) : filterItem;
					const concatenatedItems = unique(filterCategoriesItem.reduce((acc, type) => [...(categories[type] ? categories[type] : []), ...acc], []));
					filteredProducts.categories = concatenatedItems;
					relevantProducts = intersect(relevantProducts, concatenatedItems);
					break;
				}
				case 'sizes': {
					const concatenatedItems = unique(filterItem.reduce((acc, type) => [...filterArrays.sizes[type], ...acc], []));
					filteredProducts.sizes = concatenatedItems;
					relevantProducts = intersect(relevantProducts, concatenatedItems);
				}
					break;
				case 'newProducts':
					filteredProducts.newProducts = filterArrays.newProducts;
					relevantProducts = intersect(relevantProducts, filterArrays.newProducts);
					break;
				case 'productsOnSale':
					filteredProducts.productsOnSale = filterArrays.productsOnSale;
					relevantProducts = intersect(relevantProducts, filterArrays.productsOnSale);
					break;
				default:
					break;
			}
		}
	});

	return { relevantBaseProducts: baseProducts, relevantProducts, filteredProducts };
};

export default filterProducts;
